var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3Dots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "21px",
    viewBox: "0 0 26 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 26") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final-designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Case-management-overview",
    transform: "translate(-1757, -347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(529, 184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(34, 163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(1194, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    x: 0,
    y: 0,
    width: 26,
    height: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,10.5 C14,11.0668186 13.5522847,11.5263158 13,11.5263158 C12.4477153,11.5263158 12,11.0668186 12,10.5 C12,9.93318144 12.4477153,9.47368421 13,9.47368421 C13.5522847,9.47368421 14,9.93318144 14,10.5 Z M13,6.05263158 C13.5522847,6.05263158 14,5.59313435 14,5.02631579 C14,4.45949723 13.5522847,4 13,4 C12.4477153,4 12,4.45949723 12,5.02631579 C12,5.59313435 12.4477153,6.05263158 13,6.05263158 Z M13,14.9473684 C12.4477153,14.9473684 12,15.4068657 12,15.9736842 C12,16.5405028 12.4477153,17 13,17 C13.5522847,17 14,16.5405028 14,15.9736842 C14,15.4068657 13.5522847,14.9473684 13,14.9473684 Z",
    id: "Shape-Copy",
    fill: "#000000",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Dots);
export default __webpack_public_path__ + "static/media/3dots.6d363f130a19b39952580c56f9e4dcca.svg";
export { ForwardRef as ReactComponent };